import React from "react";
import { Dialog, Button } from "@blueprintjs/core";
import { FilledButton, OutlinedButton, TextButton } from "../buttons-20250224T111359Z-001/buttons";

const PublishConfirmDialog = ({
  isOpen,
  onClose,
  onConfirm
}) => {
  console.log(isOpen, "isOpen");
  return (
    <Dialog
      portalContainer={document.body}
      isOpen={isOpen}
      onClose={onClose}
      title="Confirm Final Submission"
      canEscapeKeyClose
      canOutsideClickClose
    >
      <div className="bp3-dialog-body push-30-b push-30-t" >
        <p>
          Are you sure you want to <strong>publish your self-assessment</strong>?
        </p>
        <p>
          Once submitted, <strong>you will not be able to edit</strong> your
          answers.
        </p>
      </div>

      <div className="bp3-dialog-footer" style={{ display: "flex", justifyContent: "flex-start" }}>
        <div className="bp3-dialog-footer-actions">
        <FilledButton
            text="Yes, Publish"
            onClick={onConfirm}
            style={{ marginRight: "5px" }}
          />
          <TextButton
            text="Cancel"
            onClick={onClose}
          />        
        </div>
      </div>
    </Dialog>
  );
};

export default PublishConfirmDialog;
